module.exports = __webpack_public_path__ + "static/media/phone8.b12d7492.png";